import get from 'lodash/get';

import { getLinkHref } from 'shared/helpers/uri';

export default (pageData: object) => {
  const silentLoginLink = get(pageData, 'authentication.silentLoginLink');
  return getLinkHref(silentLoginLink);
};
